<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>(My eldest son told me to write “I’m a legend!”)</p><br/>
<p>This book has been written by a highly qualified and very experienced manager, who worked in various private customer service and public service roles, over several decades.</p><br/>
<p>Some of the staff managed by the author could be described as judgmental, wilful, authoritarian, stubborn, confident, assertive, entitled, para-legal, para-military or litigious. (We can only imagine how they would describe the author!)</p><br/>
<p>The author completed all of the high-level leadership courses offered by their well-established, public organisation. One course was an interstate senior management leadership development course, with international attendees. Another course matched the author with a rotary and business mentor. The author also mentored numerous people within the author’s workplaces.</p><br/>
<p>The author seeks to assist other managers, by providing “pearls of wisdom”, and sharing observations and lessons learnt from experience (generally the hard way!).</p><br/>
<p>The author wishes:</p>
<ul>
<li><p>to save managers from embarrassment and frustration;</p></li>
<li><p>to assist managers to be more productive and avoid pitfalls;</p></li>
<li><p>they had been able to read this book, before embarking on their management career (as that might have led to skyrocketing promotions!); and</p></li>
<li><p>that all who read this book have fruitful management careers.</p></li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1a06e690